import React from "react";
import { Box, Button, Typography, styled } from "@mui/material";
import ErrorOutlineOutlined from "@mui/icons-material/ErrorOutlineOutlined";
import { logoutLocal } from "@services/auth";

const PageContainer = styled(Box)({
  background: "#fdffff",
  borderRadius: "12px",
  height: "97vh",
  display: "flex",
  flexDirection: "column",
  border: "1px solid #99d4e1",
  boxShadow: "8px 2px 58.4px 0px inset rgba(191, 242, 255, 0.2)",
  position: "relative",
  overflow: "hidden",
});

const HeaderContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "rgba(253, 255, 255, 0.2)",
  borderBottom: "1px solid #35d7e4",
  padding: "12px 64px",
  height: "124px",
  display: "flex",
  alignItems: "end",
  gap: "8px",
  position: "sticky",
  top: 0,
  zIndex: 1,
  [theme.breakpoints.down("md")]: {
    padding: "12px 24px",
    height: "96px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "8px 16px",
    height: "80px",
  },
}));

const HeaderTitle = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

const Title = styled(Typography)(({ theme }) => ({
  fontFamily: "Rethink Sans, sans-serif",
  fontSize: "28px",
  fontWeight: 500,
  lineHeight: "1.5",
  color: "#262626",
  letterSpacing: "-1px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "22px",
  },
}));

const ContentSection = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: "32px 48px 16px",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  overflowY: "auto",
  overflowX: "hidden",
  [theme.breakpoints.down("md")]: {
    padding: "24px 24px 16px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "16px 12px 16px",
  },
}));

export default function AccessRemoved() {
  const handleSignOut = async () => {
    await logoutLocal();
    window.location.href = "/login";
  };

  return (
    <PageContainer>
      <HeaderContainer>
        <HeaderTitle>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "999px",
              backgroundColor: "#FEE2E2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ErrorOutlineOutlined sx={{ fontSize: 22, color: "#DC2626" }} />
          </Box>
          <Title>Access Removed</Title>
        </HeaderTitle>
      </HeaderContainer>

      <ContentSection>
        <Box
          sx={{
            maxWidth: 720,
            width: "100%",
          }}
        >
          <Box
            sx={{
              background: "#FFF5F5",
              border: "1px solid #FECACA",
              borderRadius: "12px",
              p: 4,
              mt: 3,
            }}
          >
            <Typography
              sx={{
                color: "#262626",
                fontSize: "15px",
                fontFamily: '"Rethink Sans", sans-serif',
                lineHeight: 1.7,
              }}
            >
              Your access has been removed. If you believe this is a mistake,
              please contact your administrator.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 2, mt: 4, flexWrap: "wrap" }}>
            <Button
              onClick={() => void handleSignOut()}
              sx={{
                background:
                  "linear-gradient(90deg, #0A829D 0%, #58C2D8 100%)",
                boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.25)",
                borderRadius: "8px",
                padding: "10px 24px",
                fontFamily: '"Rethink Sans", sans-serif',
                fontWeight: 600,
                fontSize: "14px",
                color: "#e6fafc",
                textTransform: "none",
                "&:hover": {
                  background:
                    "linear-gradient(90deg, #086e86 0%, #4ab3c7 100%)",
                },
              }}
            >
              Sign Out
            </Button>
          </Box>
        </Box>
      </ContentSection>
    </PageContainer>
  );
}
